<p *ngIf="booking">
  edit-booking-detail-etc works!
</p>
